import { CLOSED_CATEGORIES } from 'utils/constants'
import partition from 'lodash/partition'

export const toActiveClosedCompanies = companies =>
  companies.reduce(
    (acc, company) => {
      const { id, name, deals } = company
      const [activeArr, closedArr] = partition(
        deals,
        deal => !CLOSED_CATEGORIES.includes(deal.status.category.code)
      )
      activeArr.length &&
        acc.active.push({
          id,
          name,
          deals: activeArr
        })
      closedArr.length &&
        acc.closed.push({
          id,
          name,
          deals: closedArr
        })
      return acc
    },
    { active: [], closed: [] }
  )
